var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNorfolkIsland(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9559 1.5886C20.8524 0.571477 18.4926 0.000976562 15.9994 0.000976562C13.5062 0.000976562 11.1464 0.571477 9.04292 1.5886L7.65161 16.001L9.04292 30.4134C11.1464 31.4305 13.5062 32.001 15.9994 32.001C18.4926 32.001 20.8524 31.4305 22.9559 30.4134L24.3472 16.001L22.9559 1.5886Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.58929C3.69156 4.17717 0 9.65773 0 16.0011C0 22.3445 3.69156 27.825 9.0435 30.4129V1.58929Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9558 1.58929V30.4129C28.3077 27.825 31.9993 22.3444 31.9993 16.0011C31.9993 9.65779 28.3077 4.17717 22.9558 1.58929Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1741 20.8708L16.0001 7.65338L11.8262 20.8708H14.9566V24.349H17.0436V20.8708H20.1741Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorfolkIsland);
export default __webpack_public_path__ + "static/media/norfolk-island.faffa6a6.svg";
export { ForwardRef as ReactComponent };